module.exports = __webpack_public_path__ + "media/corporate-image/artem-beliaikin-SiA697XF2ds-unsplash-6f3ba484d1c4b87a1df03cb2f55a0a6f.jpg";